import React from "react";
import NavbarColegio from "../components/navbar/navbar";
import Footer from "../components/footer/footer";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export default function MainLayout(){

return (

<>

<NavbarColegio />


<Box
sx={{
    mt:{xs:9, sm:5, md:14},
minHeight:"100vh",

}}
>

<Outlet />

</Box>

<Footer/>



</>

)

}